import { createContext, useContext } from 'react'

// The context object and its hook live here rather than in ThemeContext.tsx so that
// file exports only its component: a module mixing component and non-component
// exports defeats React Fast Refresh (react-refresh/only-export-components).

/**
 * Two modes only. The Fantasy, Professional, Cyberpunk and Forest families were
 * retired in W1 — every new primitive would otherwise need styling eight times.
 */
export type ThemeMode = 'light' | 'dark'

export const THEME_MODES: readonly ThemeMode[] = ['light', 'dark'] as const

export interface ThemeContextValue {
  mode: ThemeMode
  toggleTheme: () => void
  setTheme: (mode: ThemeMode) => void
  /** Human-readable label for the active mode. */
  themeName: string
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined)

export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within a ThemeContextProvider')
  }
  return context
}
